import ls from 'local-storage'

export const showColumn = (column, config) => {
  return config.includes(column)
}

export const updateTableFilterConfig = (table, checked) => {
  const tableFilterConfig = ls.get('tableFilterConfig') ?? {}
  // if (!tableFilterConfig[table]) tableFilterConfig[table] = []
  tableFilterConfig[table] = checked
  ls.set('tableFilterConfig', tableFilterConfig)
}

export const getTableFilterConfig = (tableName, optionsConfig) => {
  const tableFilterConfig = ls.get('tableFilterConfig') ?? {}
  if (!tableFilterConfig[tableName]) {
    // 只取 defaultChecked 為 true 或未設定的項目
    tableFilterConfig[tableName] = optionsConfig
      .filter(option => option.defaultChecked !== false)
      .map(option => option.value)
    ls.set('tableFilterConfig', tableFilterConfig)
    markNewColumnsSeen(tableName, optionsConfig)
  } else if (optionsConfig) {
    addNewColumns(tableName, optionsConfig, tableFilterConfig)
  }
  return tableFilterConfig[tableName]
}

// 新增的欄位（newColumn: true）：已存過欄位設定的使用者自動勾選一次；之後使用者取消勾選就照使用者的設定
const addNewColumns = (tableName, optionsConfig, tableFilterConfig) => {
  const seenConfig = ls.get('tableFilterSeenNewColumns') ?? {}
  const seen = seenConfig[tableName] ?? []
  const unseen = optionsConfig.filter(option => option.newColumn && !seen.includes(option.value))
  if (!unseen.length) return
  unseen.forEach(({ value }) => {
    if (!tableFilterConfig[tableName].includes(value)) tableFilterConfig[tableName].push(value)
  })
  seenConfig[tableName] = [...seen, ...unseen.map(({ value }) => value)]
  ls.set('tableFilterConfig', tableFilterConfig)
  ls.set('tableFilterSeenNewColumns', seenConfig)
}

// 第一次建立欄位設定時，新增的欄位已照預設勾選：記為已看過，之後使用者取消勾選才不會被加回來
const markNewColumnsSeen = (tableName, optionsConfig) => {
  const seenConfig = ls.get('tableFilterSeenNewColumns') ?? {}
  seenConfig[tableName] = optionsConfig.filter(option => option.newColumn).map(({ value }) => value)
  ls.set('tableFilterSeenNewColumns', seenConfig)
}
